import {Injectable} from '@angular/core';
import * as _Highcharts from 'highcharts';
import {ChartSettingsGeneratorService} from '@services/charts/line/chart-settings-generator.service';
import {BarChartSettingsGeneratorService} from '@services/charts/bar/bar-chart-settings-generator.service';
import {GaugeChartSettingsGeneratorService} from '@services/charts/gauge/gauge-chart-settings-generator.service';
import {PieChartSettingsGeneratorService} from '@services/charts/pie/pie-chart-settings-generator.service';
import {UserDefinedWidgetType} from '@constants/pages/user-defined-page/user-defined-widget-type';
import {LineChartSettingsParameters} from '@models/charts/line-chart-settings-parameters';
import {Observable, of} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class GeneralChartSettingsGeneratorService {

  constructor(private lineChartSettingsGeneratorService: ChartSettingsGeneratorService,
              private barChartSettingsGeneratorService: BarChartSettingsGeneratorService,
              private gaugeChartSettingsGeneratorService: GaugeChartSettingsGeneratorService,
              private pieChartSettingsGeneratorService: PieChartSettingsGeneratorService) {
  }

  public getZoomEventObservable(widgetType: UserDefinedWidgetType):Observable<any> {
    if (widgetType === UserDefinedWidgetType.LINE_WITH_SIGNALS_PER_AXIS) {
      return this.lineChartSettingsGeneratorService.zoomChangeNotification;
    }
    return of(false);
  }


  public generateChartSettings(widgetType: UserDefinedWidgetType, chartParameters: LineChartSettingsParameters): _Highcharts.Options {
    switch (widgetType) {
      case UserDefinedWidgetType.LINE_WITH_SIGNALS_PER_AXIS: {
        return this.lineChartSettingsGeneratorService.generateChartOptions(chartParameters);

      }
      case UserDefinedWidgetType.GAUGE: {
        return this.gaugeChartSettingsGeneratorService.generateChartOptions(chartParameters);
      }
      case UserDefinedWidgetType.BAR: {
        return this.barChartSettingsGeneratorService.generateChartOptions(chartParameters);
      }
      case UserDefinedWidgetType.PIE: {
        return this.pieChartSettingsGeneratorService.generateChartOptions(chartParameters);
      }
    }
    return {};
  }

  public adjustChartInteraction(chartParameters: LineChartSettingsParameters) {
    const chart = chartParameters.highchartsChart;
    if (!chart) {
      return;
    }

    if (chartParameters.isInEditMode) {
      chart.update({chart: {zooming: {type: undefined}}});
      chart.update({plotOptions: {series: {enableMouseTracking: false}}});
      chart.update({plotOptions: {series: {states: {hover: {enabled: false}}}}});
      chart.update({legend: {itemHoverStyle: {cursor: 'grab'}}});
    } else {
      chart.update({chart: {zooming: {type: 'x'}}});
      chart.update({plotOptions: {series: {states: {hover: {enabled: true}}}}});
      chart.update({legend: {itemHoverStyle: {cursor: undefined}}});
    }

  }

}
